import type { Typed } from 'services/api/fields/core';

export enum JobProcessStatus {
  Pending = 'pending',
  Running = 'running',
  Completed = 'completed',
  Error = 'error',
}

export type ExportContext = {
  exportId: string;
};

export interface JobProcessOptions {
  id: string;
  key: string | null;
  status: JobProcessStatus;
  error: string | null;
  context: Record<string, unknown>;
  [key: string]: any;
}

function getDefaults(): JobProcessOptions {
  return {
    id: '',
    key: null,
    status: JobProcessStatus.Pending,
    error: null,
    context: {},
  };
}

let JobProcess: new <T extends JobProcessOptions>(options: T) => Typed<_JobProcess<T>, T>;

class _JobProcess<T extends JobProcessOptions = JobProcessOptions> {
  status!: JobProcessStatus;

  constructor(options: T) {
    const opts = { ...getDefaults(), ...options };
    Object.assign(this, opts);

    this.status = opts.status;
  }

  get isPending() {
    return this.status === JobProcessStatus.Pending;
  }

  get isRunning() {
    return this.status === JobProcessStatus.Running;
  }

  get isError() {
    return this.status === JobProcessStatus.Error;
  }

  get isCompleted() {
    return this.status === JobProcessStatus.Completed;
  }

  get isFinished() {
    return this.isCompleted || this.isError;
  }
}

// eslint-disable-next-line prefer-const
JobProcess = _JobProcess as typeof JobProcess;

export default JobProcess;
export { JobProcess };
export type JobProcess<T extends JobProcessOptions = JobProcessOptions> = Typed<_JobProcess<T>, T>;
